import { multiplication } from "./index.js";

export function getCurrencySymbol(defaultSymbol) {
  const currentCurrencyStr = window.localStorage.getItem("currentCurrency");
  let currentCurrency = null;
  try {
    currentCurrency = JSON.parse(currentCurrencyStr);
  } catch (e) {
    console.log(e);
  }
  if (currentCurrency && currentCurrency.toCurrencyCode == "CNY") {
    return defaultSymbol;
  }
  return currentCurrency &&
    (currentCurrency.shortCode ||
      currentCurrency.symbol ||
      currentCurrency.toCurrencyCode)
    ? currentCurrency.symbol ||
        currentCurrency.shortCode ||
        currentCurrency.toCurrencyCode
    : defaultSymbol;
}

export function getCurrencyNum(num) {
  const currentCurrencyStr = window.localStorage.getItem("currentCurrency");
  let currentCurrency = null;
  try {
    currentCurrency = JSON.parse(currentCurrencyStr);
  } catch (e) {
    console.log(e);
  }

  if (currentCurrency && currentCurrency.toCurrencyCode == "CNY") {
    return num;
  }
  if (typeof num == "string") {
    num = Number(num);
  }
  return currentCurrency && currentCurrency.exchangeRate && !isNaN(num)
    ? multiplication(currentCurrency.exchangeRate, num)
    : num;
}
